<template>
  <div v-if="totalUnreadChecks > 0" :class="classes">
    {{ totalUnreadChecks }}
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, onMounted } from 'vue'
import { useSfAssistantChecksPage } from '@app/application/sf-assistant-checks/stores/page'

interface Props {
  className?: string
  workflowId?: number
}

const props = defineProps<Props>()

const classes = computed(() => {
  return (
    props.className ||
    'sf-label sf-label-danger sf-label-active sf-no-border tw-flex tw-items-center tw-justify-center tw-h-4 tw-min-w-[16px] tw-rounded-full tw-px-1 tw-leading-3'
  )
})

const sfAssistantChecksPageStore = useSfAssistantChecksPage()

const { totalUnreadChecks } = storeToRefs(sfAssistantChecksPageStore)

if (props.workflowId) {
  sfAssistantChecksPageStore.setWorkflowId(props.workflowId)
}

onMounted(() => {
  sfAssistantChecksPageStore.fetchUnreadCount()
})
</script>
